import React from 'react';
const EmptyComponent = () => React.createElement('');
export const defaultStepperState = {
    steps: {},
    activeStep: { title: '', component: EmptyComponent, key: '' },
    stepLinks: [],
    activeIndex: 0,
    methods: {
        previous: () => {
            null;
        },
        next: () => {
            null;
        },
        toStep: () => {
            null;
        },
    },
};
